<template>
<div>
  <div class="btn-topology-expand">
    <a class="btn btn-default" @click="isMini = !isMini">
      <span v-if="isMini"><i class="fa fa-search-plus"></i> Expand Diagram</span>
      <span v-else><i class="fa fa-search-minus"></i> Shrink Diagram</span>
    </a>
  </div>
  <div class="topology-diagram horizontal" :class="{ 'mini': isMini }">
      <div class="topology-hosts">
          <h5>Branch Hosts</h5>
          <div class="topology-host" v-for="host in branchHosts">
              <div class="status riverbed" :title="host.group_alias"><div class="circle"></div>&nbsp;</div>
              <div class="vm-name">{{ host.group_alias }}</div>
          </div>
      </div>
      <ul class="topology-images">
          <li><img :src="branchOptimizationImage"></li>
          <li><img :src="branchNetworkImage"></li>
          <li><img :src="wanImage"></li>
          <li><img :src="datacenterNetworkImage"></li>
          <li><img :src="datacenterOptimizationImage"></li>
      </ul>
      <div class="topology-hosts">
          <h5>Datacenter Hosts</h5>
          <div class="topology-host" v-for="host in datacenterHosts">
              <div class="status riverbed" data-toggle="tooltip" data-placement="top" :title="host.group_alias"><div class="circle"></div>&nbsp;</div>
              <div class="vm-name">{{ host.group_alias }}</div>
          </div>
      </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    blueprint: {
      type: Object,
      required: true
    },
    minimal: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isMini: this.minimal,
    }
  },

  computed: {
    branchNetworkImage() {
      return this.diagramImage(
        _.first(this.groupsByTier(1))
      )
    },

    branchOptimizationImage() {
      return this.diagramImage(
        _.first(this.groupsByTier(2))
      )
    },

    branchHosts() {
      return this.groupsByTier(3)
    },

    wanImage() {
      if(this.totalWanConnections == 2) {
        return "/images/topologies/wan-dual-horizontal.png"
      }

      return "/images/topologies/wan-single-horizontal.png"
    },

    totalWanConnections() {
      return this.blueprint.blueprint_wan_path_count
    },

    datacenterNetworkImage() {
      return this.diagramImage(
        _.first(this.groupsByTier(5))
      )
    },

    datacenterOptimizationImage() {
      return this.diagramImage(
        _.first(this.groupsByTier(6))
      )
    },

    datacenterHosts() {
      return this.groupsByTier(7)
    },


  },

  methods: {
    groupsByTier: function (tierId) {
      return this.blueprint.topology_groups
        .map(function(topology_group) {
          return topology_group.image_group
        })
        .filter(function (image_group) {
          return image_group.image_tier_id == tierId
        })
        .sort(function(a, b) {
            let textA = a.group_name.toUpperCase()
            let textB = b.group_name.toUpperCase()
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
    },

    diagramImage: function (group) {
      return "/images/topologies/" +
        group.group_alias +
        "-horizontal.png"
    },
  }
}
</script>
